import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { WorkflowStep } from "@/types/workflow";
import { Json } from "@/integrations/supabase/types";

export const useWorkflowStatus = (caseId: string, onWorkflowUpdate: () => void) => {
  const [updating, setUpdating] = useState(false);
  const { toast } = useToast();

  const updateStepStatus = async (stepIndex: number, newStatus: WorkflowStep["status"], workflow: WorkflowStep[]) => {
    console.log("Starting status update:", { stepIndex, newStatus });
    setUpdating(true);
    try {
      const updatedWorkflow = workflow.map((step, index) => {
        if (index === stepIndex) {
          return { ...step, status: newStatus };
        }
        return step;
      });

      // Convert WorkflowStep[] to Json type for Supabase
      const workflowJson = updatedWorkflow.map(step => ({
        title: step.title,
        description: step.description,
        status: step.status,
        estimated_time: step.estimated_time,
        legal_references: step.legal_references || [],
        required_documents: step.required_documents || [],
        needs_documentation: step.needs_documentation || false,
        document_type: step.document_type,
        helpful_resources: step.helpful_resources || []
      })) as Json[];

      const { error } = await supabase
        .from('cases')
        .update({ workflow: workflowJson })
        .eq('id', caseId);

      if (error) throw error;

      toast({
        title: "Status oppdatert",
        description: "Workflow steget har blitt oppdatert.",
      });

      onWorkflowUpdate();
    } catch (error: any) {
      console.error('Error updating workflow status:', error);
      toast({
        title: "Feil",
        description: "Kunne ikke oppdatere workflow status. Vennligst prøv igjen.",
        variant: "destructive",
      });
    } finally {
      setUpdating(false);
    }
  };

  return {
    updating,
    updateStepStatus,
  };
};